// embodiment 표시 포맷(formatEmbodimentName/Meta 등)은 공용 모듈(@/components/embodiment)이
// 제공한다. 여기에는 리뷰 화면 전용 포맷터만 둔다.

import type { DatasetStatus } from "@/api";
import { formatDateTime, parseUtcMs } from "@/utils/datetime";

// dataset status 한글 표기. 리뷰 큐가 status 를 표에 그리는 유일한 화면이므로 여기서 소유한다.
// 다른 화면이 생기면 @/components/dataset 로 옮긴다. 큐 응답은 available / archived 만 포함한다
// (BE 큐 조건이 catalog status 로 제한). 그래도 타입의 모든 값을 정의해, 값이 추가될 때 어긋나지 않게 한다.
const datasetStatusLabels: Record<DatasetStatus, string> = {
  pending: "처리를 기다리고 있습니다.",
  uploading: "업로드 중입니다.",
  available: "사용할 수 있습니다.",
  archived: "보관된 Dataset입니다.",
  cancelled: "업로드가 취소되었습니다.",
};

export function formatDatasetStatus(status: DatasetStatus): string {
  return datasetStatusLabels[status];
}

// 리뷰 큐 셀의 시각. 앱 표준 시각 형식(formatDateTime)을 쓴다.
export function formatTimestamp(iso: string): string {
  return formatDateTime(parseUtcMs(iso));
}
